import { Injectable } from '@angular/core';

export interface Environment {
  customerName?: string;
  environmentName?: string;
  version?: string;
  featureFlags: {
    machineLearningEstimation: {
      enabled: boolean;
    };
    chargeInformationFee: {
      enabled: boolean;
    };
  };
}

/**
 * Service responsible for providing the runtime application configuration.
 *
 * Configuration is loaded via a `fetch()` call in `main.ts` **before**
 * `bootstrapApplication` is called, so `settings` is synchronously available
 * when Angular's DI resolves any provider.
 *
 * In development, `public/assets/config/app-config.json` is committed with dev
 * values and served as-is by `ng serve`.
 * In production, `docker-entrypoint.sh` writes the file from `APP_*` env vars
 * at container startup before nginx serves any request.
 */
@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private static _config: Environment;

  /**
   * Called once from `main.ts` before bootstrapping to store the loaded config.
   */
  static initialise(config: Environment): void {
    AppConfigService._config = config;
  }

  /** The loaded runtime configuration. Always populated before DI resolves. */
  get settings(): Environment {
    return AppConfigService._config;
  }
}
